<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    destroy-on-close
    append-to-body
    @close="$emit('close')"
    width="80%"
    top="5vh"
    class="over"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex mt-1 gap-1">
          <span
            v-for="(type, index) in orderType"
            :key="index"
            v-bind:style="getMenuStyle(type)"
            style="cursor: pointer"
          >
            <div @click="handleChangeTab(type.value)" class="p-2">
              {{ type.label }}
            </div>
          </span>
        </div>
      </div>
    </template>

    <div
      v-if="activeTab === 1"
      class="container-fluid py-1"
      style="height: calc(100vh - 240px); overflow-y: auto"
    >
      <div class="row g-2">
        <!-- Cột 1: Thông tin đơn hàng -->
        <div class="col-md-6">
          <div class="border p-2 rounded">
            <div class="d-flex align-items-center mb-2">
              <span class="material-icons me-1" style="font-size: 20px"
                >shopping_bag</span
              >
              <span class="fw-bold" style="font-size: 16px"
                >Thông tin đơn hàng</span
              >
            </div>
            <div class="d-flex gap-2 mb-2">
              <div class="row mb-2">
                <!-- Cột trái -->
                <div class="col">
                  <span class="fw-500"
                    >Chọn cửa hàng <span class="text-danger">*</span></span
                  >
                  <el-select
                    class="mt-1 w-100"
                    v-model="selectedWarehouse"
                    placeholder="Chọn cửa hàng"
                    size="small"
                  >
                    <el-option
                      v-for="item in warehouses"
                      :key="item.value"
                      :label="item.name"
                      :value="item.wid"
                    ></el-option>
                  </el-select>
                </div>

                <!-- Cột phải -->
                <div class="col">
                  <span class="fw-500"
                    >Chính sách giá <span class="text-danger">*</span></span
                  >
                  <el-select
                    class="mt-1 w-100"
                    v-model="price_policy"
                    placeholder="Select"
                    size="small"
                  >
                    <el-option
                      v-for="item in options_price_policy"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <el-input
              class="mt-2"
              placeholder="Thêm sản phẩm"
              size="small"
              v-model="searchProduct"
              @input="searchProductWid"
            >
              <template slot="prefix">
                <IconFont class="mt-2" name="icon-search"></IconFont>
              </template>
            </el-input>
            <div
              v-if="activeSearch && loadingSearch === false"
              class="search-suggestions"
            >
              <div>
                <div
                  role="button"
                  v-for="(product, index) of listSearchedPrd"
                  :key="index"
                  class="add-prd p-8 border-bottom"
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                    @click="
                      addProductToOrder(product), (activeSearch = null);
                      searchProduct = '';
                    "
                  >
                    <div
                      v-if="product.type === 'combo'"
                      class="p-1 d-flex justify-content-center w-100 align-items-center"
                    >
                      <div>
                        <el-image
                          style="
                            height: 64px;
                            width: 64px;
                            border-radius: 4px;
                            border: 1px solid #eaecf2;
                          "
                          :src="product.image"
                        ></el-image>
                      </div>
                      <div class="ms-2 flex-grow-1" style="width: 175px">
                        <div v-if="product.type === 'combo'" class="combo">
                          COMBO
                        </div>
                        <span
                          class="text-blue500 fw-bold text-ellipsis-1-line"
                          >{{ product.name }}</span
                        >
                        <div class="d-flex">
                          <div
                            class="pe-1"
                            style="
                              width: 60% !important;
                              border-right: 1px solid rgba(220, 223, 233, 0.5);
                            "
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="`${product.code}`"
                              placement="top"
                            >
                              <span class="text-ellipsis-1-line">{{
                                product.code
                              }}</span>
                            </el-tooltip>
                          </div>
                          <div class="ms-2">
                            {{
                              new Intl.NumberFormat("vi-VN", {
                                style: "currency",
                                currency: "VND",
                              }).format(product.retailPrice)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="p-1 d-flex justify-content-center w-100">
                      <div>
                        <el-image
                          style="
                            height: 64px;
                            width: 64px;
                            border-radius: 4px;
                            border: 1px solid #eaecf2;
                          "
                          :src="product.image"
                        ></el-image>
                      </div>
                      <div class="ms-2 flex-grow-1" style="width: 175px">
                        <span
                          class="text-blue500 fw-bold text-ellipsis-2-line"
                          >{{ product.name }}</span
                        >
                        <div class="d-flex">
                          <div
                            class="pe-1"
                            style="
                              width: 60% !important;
                              border-right: 1px solid rgba(220, 223, 233, 0.5);
                            "
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="`${product.code}`"
                              placement="top"
                            >
                              <span class="text-ellipsis-1-line">{{
                                product.code
                              }}</span>
                            </el-tooltip>
                          </div>
                          <div class="ms-2">
                            {{
                              new Intl.NumberFormat("vi-VN", {
                                style: "currency",
                                currency: "VND",
                              }).format(product.retailPrice)
                            }}
                          </div>
                        </div>
                        <div
                          class="mt-2 pt-1"
                          style="
                            border-top: 1px solid rgba(220, 223, 233, 0.5);
                            font-size: 12px;
                          "
                        >
                          <div class="d-block">
                            Tồn kho:
                            {{ getStoreStock(product.code).total }}
                            - Giữ hàng:
                            {{ getStoreStock(product.code).book }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-table
              :data="orderParam.items"
              border
              class="mt-2"
              style="width: 100%"
              height="300px"
              v-if="orderParam.items.length > 0"
            >
              <el-table-column
                prop="name"
                label="Tên sản phẩm"
                min-width="160"
              ></el-table-column>
              <el-table-column label="Giá bán" width="170" align="center">
                <template #default="{ row }">
                  <el-input
                    :value="
                      separateNumberByThousand(
                        price_policy === 'retail_price'
                          ? row.retailPrice
                          : row.wholesalePrice
                      )
                    "
                    @input="handleInputFormat($event, 'product', row)"
                    @keypress.native="isNumber($event)"
                    size="small"
                  >
                    <template slot="suffix">
                      <div style="padding-top: 6px">đ</div>
                    </template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="Số lượng" width="155" align="center">
                <template #default="{ row }">
                  <el-input-number
                    v-model="row.amount"
                    :min="1"
                    size="small"
                    @change="updateOrderSwItems($event, row.code)"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="Thành tiền" width="130" align="center">
                <template #default="{ row }">
                  {{
                    separateNumberByThousand(
                      (price_policy === "retail_price"
                        ? Number(row.retailPrice) || 0
                        : Number(row.wholesalePrice) || 0) *
                        (Number(row.amount) || 0)
                    )
                  }}
                  đ
                </template>
              </el-table-column>
              <el-table-column label="Hành động" align="center" width="90">
                <template #default="{ row }">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    @click="removeProductFromOrder(row.code)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- Hiển thị khi danh sách trống -->
            <div
              v-else
              class="d-flex flex-column align-items-center justify-content-center text-center py-4"
            >
              <i
                class="el-icon-box"
                style="font-size: 50px; color: #909399"
              ></i>
              <p class="mt-2 text-grey">Chưa có thông tin sản phẩm</p>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-4">
                <el-input
                  v-model="orderParam.note_customer"
                  class="w-100"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  maxlength="230"
                  :rows="3"
                  placeholder="Ghi chú đơn hàng"
                ></el-input>
              </div>
              <div class="col-4 text-center fw-bold">Tổng tiền hàng:</div>
              <div class="col-4 text-end fw-bold text-danger">
                <div class="font-weight-600">
                  {{ separateNumberByThousand(totalNoFee) }} đ
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cột 2: Thông tin khách hàng + ĐVVC + kiện hàng -->
        <div class="col-md-3">
          <div class="border p-2 rounded mb-2">
            <div class="d-flex align-items-center mb-2">
              <span class="material-icons me-1" style="font-size: 20px"
                >account_circle</span
              >
              <span class="fw-bold" style="font-size: 16px"
                >Thông tin khách hàng</span
              >
            </div>
            <div style="border: 1px solid #e4e4e4; border-radius: 4px">
              <div class="d-flex my-1 mx-2 justify-content-between">
                <div class="d-flex">
                  <IconFont
                    class="me-2"
                    style="margin-top: 3px"
                    name="el-icon-s-custom"
                  ></IconFont>
                  <div
                    style="font-weight: 500; max-width: 120px !important"
                    class="text-ellipsis"
                  >
                    {{ contact.displayName }}
                  </div>
                </div>
                <div
                  style="
                    text-decoration: underline;
                    cursor: pointer;
                    color: blue;
                  "
                  @click="getHistoryPhone"
                >
                  Gần đây
                </div>
              </div>
              <div class="mx-2 mb-1" style="border-top: 1px solid #e4e4e4">
                <div class="d-flex justify-content-between mt-1">
                  <div class="d-flex">
                    <IconFont
                      class="mt-1 me-2"
                      name="el-icon-location"
                    ></IconFont>
                    <span style="font-weight: 500">Địa chỉ giao hàng</span>
                  </div>
                  <div
                    style="
                      text-decoration: underline;
                      cursor: pointer;
                      color: blue;
                    "
                    @click="dialogAddress = true"
                  >
                    Thay đổi
                  </div>
                </div>
                <div>
                  <span
                    style="font-weight: 500; margin-top: 0"
                    class="text-ellipsis"
                    >{{ contact.displayName }}</span
                  >
                  -
                  <span style="color: blue; font-weight: 500">{{
                    contact.phone
                  }}</span>
                </div>
                <!-- áp dụng địa chỉ sử dụng vào đây -->
                <div v-if="appliedAddress.address">
                  {{ appliedAddress.address }}
                </div>
                <div v-else class="text-danger">
                  * Vui lòng chọn địa chỉ giao hàng
                </div>
              </div>
              <div
                v-if="infoSuggest.length"
                class="border p-2"
                style="border-radius: 4px"
              >
                <div class="font-weight-600">Địa chỉ đơn đặt hàng gần nhất</div>
                <div v-for="cus in infoSuggest" :key="cus._id" class="mt-1">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">{{ cus.name }}</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Sử dụng thông tin"
                      placement="top"
                    >
                      <el-button
                        type="success"
                        size="mini"
                        icon="el-icon-plus"
                        style="padding: 3px 5px"
                        @click="useInfoSuggest(cus)"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Bỏ thông tin"
                      placement="top"
                    >
                      <el-button
                        class="ms-1"
                        type="danger"
                        size="mini"
                        icon="el-icon-close"
                        style="padding: 3px 5px"
                        @click="infoSuggest = []"
                      ></el-button>
                    </el-tooltip>
                  </div>
                  <div class="mt-1 mb-1">{{ cus.phone }}</div>
                  <div>
                    {{
                      [
                        cus.address,
                        app.localData.wards[cus.wardId].name || "",
                        app.localData.districts[cus.districtId].name || "",
                        app.localData.provinces[cus.provinceId].name || "",
                      ].join(",")
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="border p-2 rounded mb-2">
            <div class="d-flex align-items-center mb-2">
              <span class="material-icons me-1" style="font-size: 20px"
                >local_shipping</span
              >
              <span class="fw-bold" style="font-size: 16px"
                >Thông tin ĐVVC</span
              >
            </div>
            <div class="fw-500">
              Hình thức<span class="text-danger">*</span>
            </div>
            <el-select
              class="mt-1 w-100 input-mx-8px"
              v-model="orderParam.logistic"
              placeholder="Chọn phương thức vận chuyển"
              size="mini"
            >
              <el-option :key="'TVC'" :label="'Tự vận chuyển'" :value="'TVC'">
              </el-option>
              <el-option
                v-for="item in logisticItems.filter((s) => s.connected)"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <div v-if="orderParam.logistic === 'TVC'" class="mt-2 m-body">
              <el-input
                class="mt-1 input-mx-8px"
                v-model="shipping_fee"
                @input="handleInputFormat($event, 'shippingFee')"
                placeholder="Nhập phí vận chuyển"
                size="small"
              >
                <template slot="suffix">
                  <div style="padding-top: 6px">đ</div>
                </template>
              </el-input>
            </div>
            <div v-if="orderParam.logistic !== 'TVC'" class="fw-500 mt-2">
              Nhãn đơn hàng
            </div>
            <el-select
              v-if="orderParam.logistic !== 'TVC'"
              class="mt-1 input-mx-8px w-100"
              v-model="tag_logistic"
              placeholder="Chọn nhãn đơn hàng"
              size="small"
            >
              <el-option
                v-for="item in options_tag_logistic_computer"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="mt-2 m-body">
              <div class="fw-500">Ghi chú cho đơn vị vận chuyển</div>
              <el-input
                class="mt-1 input-mx-8px"
                row="3"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                maxlength="230"
                placeholder="Thêm thông tin ghi chú"
                size="mini"
                v-model="orderParam.note_shipper"
              ></el-input>
            </div>
          </div>

          <div v-if="orderParam.logistic !== 'TVC'" class="border p-2 rounded">
            <div class="m-body">
              <span class="fw-bold" style="font-size: 16px">Kiện hàng</span>
              <div class="mt-2 d-flex justify-content-lg-between">
                <el-input
                  class="me-2 input-mx-8px"
                  v-model="orderParam.package.width"
                  @keypress.native="isNumber($event)"
                  placeholder="Chiều dài"
                  size="mini"
                >
                  <template slot="suffix">
                    <div style="padding-top: 5px">cm</div>
                  </template>
                </el-input>
                <el-input
                  class="input-mx-8px"
                  v-model="orderParam.package.length"
                  @keypress.native="isNumber($event)"
                  placeholder="Chiều rộng"
                  size="mini"
                >
                  <template slot="suffix">
                    <div style="padding-top: 5px">cm</div>
                  </template>
                </el-input>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between">
                <el-input
                  class="me-2 input-mx-8px"
                  v-model="orderParam.package.height"
                  @keypress.native="isNumber($event)"
                  placeholder="Chiều cao"
                  size="mini"
                >
                  <template slot="suffix">
                    <div style="padding-top: 5px">cm</div>
                  </template>
                </el-input>
                <el-input
                  class="input-mx-8px"
                  v-model="orderParam.package.weight"
                  @keypress.native="isNumber($event)"
                  placeholder="Khối lượng"
                  size="mini"
                >
                  <template slot="suffix">
                    <div style="padding-top: 5px">kg</div>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>

        <!-- Cột 3: Chính sách áp dụng + Thông tin thanh toán -->
        <div class="col-md-3">
          <div class="border p-2 rounded mb-2">
            <div class="d-flex align-items-center mb-2">
              <span class="material-icons me-1" style="font-size: 20px"
                >loyalty</span
              >
              <span class="fw-bold" style="font-size: 16px"
                >Chính sách áp dụng</span
              >
            </div>
            <div class="mt-2">
              <div>
                <div class="fw-500">Chiết khấu</div>
                <el-input
                  class="input-discount input-mx-8px mt-1"
                  @keypress.native="isNumber($event)"
                  v-model="discount"
                  @input="handleInputFormat($event, 'discount')"
                  placeholder="Chiết khấu"
                  size="small"
                >
                  <template slot="suffix">
                    <div class="d-flex" style="padding-top: 6px">
                      <el-button
                        size="mini"
                        style="padding: 3px !important; width: 20px"
                        :class="
                          orderParam.typeDiscount === 'VND'
                            ? 'btn-active-1'
                            : ''
                        "
                        @click="changeDiscountType('VND')"
                        >đ</el-button
                      >
                      <el-button
                        size="mini"
                        style="
                          padding: 3px !important;
                          margin-left: 3px;
                          width: 20px;
                        "
                        :class="
                          orderParam.typeDiscount === 'percent'
                            ? 'btn-active-1'
                            : ''
                        "
                        @click="changeDiscountType('percent')"
                        >%</el-button
                      >
                    </div>
                  </template>
                </el-input>
              </div>
            </div>
            <div class="mt-2 m-body">
              <div class="fw-500">Phụ thu</div>
              <el-input
                class="mt-1 input-mx-8px"
                v-model="otherFee"
                @input="handleInputFormat($event, 'otherFee')"
                placeholder="Nhập phụ thu"
                size="small"
              >
                <template slot="suffix">
                  <div style="padding-top: 6px">đ</div>
                </template>
              </el-input>
            </div>
            <div class="mt-2 m-body">
              <div class="fw-500">
                Người trả phí vận chuyển<span class="text-danger">*</span>
              </div>
              <div class="d-flex mt-1">
                <el-button
                  :class="orderParam.payment_type_id === 1 ? 'btn-active' : ''"
                  class="w-50 me-1"
                  size="small"
                  @click="orderParam.payment_type_id = 1"
                  >Người bán</el-button
                >
                <el-button
                  :class="orderParam.payment_type_id === 2 ? 'btn-active' : ''"
                  class="w-50 ms-1"
                  size="small"
                  @click="orderParam.payment_type_id = 2"
                  >Người mua</el-button
                >
              </div>
            </div>
          </div>

          <div class="border p-2 rounded">
            <div class="d-flex align-items-center mb-2">
              <span class="material-icons me-1" style="font-size: 20px"
                >credit_card</span
              >
              <span class="fw-bold" style="font-size: 16px"
                >Khách hàng trả trước</span
              >
            </div>
            <el-input
              v-model="paid"
              class="input-mx-8px"
              @keypress.native="isNumber($event)"
              @input="handleInputFormat($event, 'paid')"
              placeholder="Số tiền thanh toán"
              size="small"
            >
              <template slot="suffix">
                <div style="padding-top: 6px">đ</div>
              </template>
            </el-input>
            <div class="mt-3 d-flex justify-content-between">
              <div class="fw-500">Doanh thu đơn hàng:</div>
              <div class="font-weight-600">
                {{
                  orderParam.logistic === "TVC" &&
                  orderParam.payment_type_id === 1
                    ? separateNumberByThousand(
                        (Number(orderParam.totalPrice) || 0) -
                          (Number(orderParam.shipping_fee) || 0)
                      )
                    : separateNumberByThousand(
                        Number(orderParam.totalPrice) || 0
                      )
                }}
                đ
              </div>
            </div>
            <div class="mt-1 pb-1 d-flex justify-content-between">
              <div class="fw-bold">Tiền COD:</div>
              <div class="font-weight-600">
                {{ separateNumberByThousand(orderParam.pickMoney || 0) }} đ
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="activeTab === 2"
      style="height: calc(100vh - 240px); overflow-y: auto"
      class="mx-3"
    >
      <div v-if="ordersHistory.length">
        <div
          v-for="order in ordersHistory"
          :key="order.code"
          class="font-14 mt-2"
        >
          <div
            class="m-body"
            style="border: 1px solid #e4e4e4; border-radius: 4px"
          >
            <div
              class="d-flex justify-content-between align-items-center px-2 pt-1"
            >
              <div class="text-grey700">
                <span class="fw-500">Thời gian tạo đơn: </span>
                <span>{{ convertTime(order.createdAt) }}</span>
              </div>
              <el-badge
                class="fw-semibold font-size-11 px-1"
                :style="{
                  color: app.colorOrder[order.state],
                  'background-color': setTransparencyHex(
                    app.colorOrder[order.state],
                    0.2
                  ),
                  'border-color': setTransparencyHex(
                    app.colorOrder[order.state],
                    0.2
                  ),
                  'border-radius': '4px',
                  'margin-top': '2px',
                }"
              >
                {{ order.state }}
              </el-badge>
            </div>
            <div
              class="d-flex align-items-center border-bottom px-2"
              style="margin-top: 6px; padding-bottom: 6px"
            >
              <div class="me-1 fw-500">Mã đơn hàng:</div>
              <div
                class="text-primary fw-700"
                role="button"
                @click="showOrderDetail(order)"
              >
                {{ order.code }}
              </div>
              <div @click="copy(order.code)" role="button">
                <IconFont name="icon-copy"></IconFont>
              </div>
            </div>
            <div>
              <div class="mt-1 px-2">
                <span class="fw-500 me-1">Số điện thoại:</span>
                <span class="text-primary">{{ order.customer.phone }}</span>
              </div>
              <div class="mt-1 px-2">
                <span class="fw-500 me-1">Địa chỉ:</span>
                <span>
                  {{
                    [
                      order.customer.address,
                      app.localData.wards[order.customer.wardId].name || "",
                      app.localData.districts[order.customer.districtId].name ||
                        "",
                      app.localData.provinces[order.customer.provinceId].name ||
                        "",
                    ].join(",")
                  }}
                </span>
              </div>
              <div
                class="fw-700 mt-2 px-2"
                style="color: rgba(122, 127, 131, 0.72)"
              >
                Sản phẩm
              </div>
              <div class="mt-1 border-bottom pb-2 px-2" v-if="order.swItems">
                <div
                  class="p-2 items d-flex align-items-center"
                  role="button"
                  @click="showOrderDetail(order)"
                >
                  <div style="height: 54px">
                    <el-image
                      style="
                        height: 54px;
                        width: 54px;
                        border-radius: 4px;
                        border: 1px solid #eaecf2;
                      "
                      :src="order.swItems[0].image"
                    ></el-image>
                  </div>
                  <div class="ms-2 font-12 flex-grow-1">
                    <span class="fw-bold text-ellipsis-2-line">{{
                      order.swItems[0].name
                    }}</span>
                    <div style="opacity: 70%">
                      Số lượng: {{ order.swItems[0].amount }} x
                      {{
                        order.price_policy === "retail_price"
                          ? separateNumberByThousand(order.swItems[0].price)
                          : separateNumberByThousand(
                              order.swItems[0].wholesale_price
                            )
                      }}
                      đ
                    </div>
                    <div style="opacity: 70%">
                      Thành tiền:
                      <span class="fw-500">
                        {{
                          separateNumberByThousand(
                            (Number(order.swItems[0].amount) || 0) *
                              (order.price_policy === "retail_price"
                                ? Number(order.swItems[0].price) || 0
                                : Number(order.swItems[0].wholesale_price) || 0)
                          )
                        }}
                        đ
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="order.swItems.length > 1"
                  class="p-2 items text-center text-primary"
                  style="margin-top: 6px"
                  @click="showOrderDetail(order)"
                  role="button"
                >
                  +{{ order.swItems.length - 1 }} sản phẩm khác
                </div>
              </div>
            </div>
            <div class="pb-2">
              <div class="mt-2 d-flex justify-content-lg-between fw-500 px-2">
                <div>Tổng tiền:</div>
                <div>{{ separateNumberByThousand(order.totalPrice) }} đ</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between fw-500 px-2">
                <div>Phí vận chuyển:</div>
                <div>{{ separateNumberByThousand(order.shippingFee) }} đ</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between fw-500 px-2">
                <div>Phương thức thanh toán:</div>
                <div>{{ order.selectedPayment }}</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between fw-500 px-2">
                <div>Thành tiền:</div>
                <div>{{ separateNumberByThousand(order.pickMoney) }} đ</div>
              </div>
            </div>
          </div>
          <!-- <div class="mt-12px" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)">
          </div> -->
        </div>
      </div>
      <div v-else class="mt-2 d-flex">
        <div class="empty-items flex-grow-1">
          <el-image
            class="rounded"
            :src="require('@/assets/icons/empty_product.svg')"
            style="
              height: 68px;
              min-width: 68px;
              object-fit: cover;
              margin-top: 50px;
            "
          ></el-image>
          <span class="fw-500">Bạn chưa có đơn hàng nào !</span>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 1" class="px-12 py-12 border-top">
      <div class="d-flex justify-content-lg-end w-100">
        <el-button size="small" @click="$emit('close')">Hủy</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :disabled="disabledBtnSubmit"
          >Tạo đơn</el-button
        >
      </div>
    </div>

    <el-dialog
      class="hidden-header"
      width="60vw"
      v-if="showDetailOrder"
      :visible.sync="showDetailOrder"
      append-to-body
    >
      <OrderDetail
        :order="orderDetail"
        @close="showDetailOrder = false"
      ></OrderDetail>
    </el-dialog>

    <!-- Dialog update address -->
    <el-dialog
      title="Cập nhật địa chỉ"
      v-if="dialogAddress"
      :visible="true"
      :close-on-click-modal="false"
      :show-close="false"
      @close="dialogAddress = false"
      append-to-body
    >
      <div class="mx-3 my-2">
        <el-input
          class="mt-2 input-mx-8px"
          type="textarea"
          row="3"
          placeholder="Thêm địa chỉ chi tiết"
          size="small"
          v-model="orderParam.customer_address"
        ></el-input>
        <div class="mt-2">
          <multiselect
            class="pointer"
            selectedLabel=""
            deselectLabel=""
            selectLabel=""
            v-model="provincesSelected"
            :options="provinces"
            @input="chooseProvince('')"
            placeholder="Tỉnh, Thành Phố"
            label="name"
            track-by="name"
          >
          </multiselect>
        </div>
        <div class="mt-2">
          <multiselect
            selectedLabel=""
            deselectLabel=""
            selectLabel=""
            :options="districts"
            v-model="districtsSelected"
            placeholder="Quận, Huyện"
            class="pointer"
            label="name"
            track-by="name"
            @input="chooseDistrict('')"
          >
          </multiselect>
        </div>
        <div class="mt-2">
          <multiselect
            class="pointer"
            selectedLabel=""
            deselectLabel=""
            selectLabel=""
            :options="wards"
            v-model="wardSelected"
            :showPointer="true"
            @input="chooseWard('')"
            label="name"
            placeholder="Phường Xã"
            track-by="name"
          >
            <span class="text-danger" slot="noOptions"
              >Bạn chưa chọn quận, huyện</span
            >
          </multiselect>
        </div>
      </div>
      <div class="px-12 py-12 border-top">
        <div class="d-flex justify-content-lg-end w-100">
          <el-button
            size="small"
            @click="
              dialogAddress = false;
              changeAddress();
            "
            >Đóng</el-button
          >
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>
import { HTTP } from "@/lib/http-common";
import Multiselect from "../common/vue-multiselect/src/Multiselect.vue";
import OrderDetail from "./OrderDetail.vue";

export default {
  props: ["contact"],
  components: { multiselect: Multiselect, OrderDetail },
  data() {
    return {
      provinces: [],
      provincesSelected: null,
      districts: [],
      districtsSelected: null,
      wards: [],
      wardSelected: null,
      orderParam: {
        company_id: "",
        createdBy: "",
        customer_address: "",
        customer_district_id: null,
        customer_name: "",
        customer_phone: "",
        customer_phoneExtend: "",
        customer_province_id: null,
        customer_ward_id: null,
        items: [],
        // note: "",
        note_customer: "",
        note_shipper: "",
        price_policy: "retail_price",
        paid: null,
        otherFee: null,
        payment_type_id: 1,
        tag_logistic: { value: "", text: "" },
        package: { height: 10, width: 10, length: 10, weight: 0.2 },
        logistic: "",
        source: "swZalo",
        channel: "Salework" /* Nguồn gửi */,
        discount: null /* Chiết khấu */,
        shipping_fee: null /* Phí vận chuyển */,
        contactDate: "",
        totalPrice: 0,
        typeDiscount: "VND",
      },
      warehouses: [],
      selectedWarehouse: null,
      options_price_policy: [
        { value: "retail_price", text: "Bán lẻ" },
        { value: "wholesale_price", text: "Bán buôn" },
      ],
      price_policy: "retail_price",
      searchProduct: null,
      activeSearch: null,
      listSearchedPrd: [],
      loadingSearch: null,
      logisticItems: [
        {
          id: "JNT",
          name: "J&T Express",
          price: "",
          selected: false,
          image:
            "https://vinh-cat.com.vn/wp-content/uploads/2021/01/article_1564050459_674.png",
          connected: false,
        },
        {
          id: "GHN",
          name: "Giao hàng nhanh",
          price: "",
          selected: false,
          image:
            "https://help.shopee.vn/servlet/rtaImage?eid=ka05j000000oXwC&feoid=00N6F00000Rj6Gl&refid=0EM6F000007mCj1",
          connected: false,
        },
        {
          id: "SUPERSHIP",
          name: "Super Ship",
          price: "",
          selected: false,
          image:
            "https://play-lh.googleusercontent.com/qL5rWNpSrrCD2NIoXIBPy9iFw1bGFWq4R6G0Htj27dm0LHCle8NXqXFSz9BOBsgQJc8",
          connected: false,
        },
        {
          id: "Viettel Post",
          name: "Viettel Post",
          price: "",
          selected: false,
          image:
            "https://viettelpost.com.vn/wp-content/uploads/2020/03/logo-380x270.jpg",
          connected: false,
        },
        {
          id: "GHTK",
          name: "Giao hàng tiết kiệm",
          price: "",
          selected: false,
          image:
            "https://cdn.nhanh.vn/cdn/store/26/artCT/42374/giao_hang_tiet_kiem.png",
          connected: false,
        },
        {
          id: "CNTSHIP",
          name: "CNTSHIP(nội thành)",
          price: "",
          selected: false,
          image:
            "https://cdn.nhanh.vn/cdn/store/26/artCT/42374/giao_hang_tiet_kiem.png",
          connected: false,
        },
        {
          id: "sps",
          name: "Ninja van",
          price: "",
          selected: false,
          image: "",
          connected: false,
        },
        {
          id: "Shopee Xpress",
          name: "Shopee Xpress",
          price: "",
          selected: false,
          image:
            "https://deo.shopeemobile.com/shopee/shopee-spx-live-vn/static/media/logo.6f321ec3.svg",
          connected: false,
        },
        {
          id: "AHAMOVE",
          name: "Ahamove",
          price: "",
          selected: false,
          image: "https://www.ahamove.com/static/icons/Logo.svg",
          connected: false,
        },
      ],
      options_tag_logistic: [
        { value: 1, text: "Dễ vỡ" },
        { value: 7, text: "Nông sản/thực phẩm khô" },
      ],
      tag_logistic: "",
      loading: false,
      infoSuggest: [],
      discount: null,
      paid: null,
      otherFee: null,
      shipping_fee: null /* Phí vận chuyển */,
      ordersHistory: [],
      showDetailOrder: false,
      orderDetail: {},
      appliedAddress: {},
      dialogAddress: false,
      updatePrice: null,

      activeTab: 1,
      orderType: [
        { value: 1, label: "Lên đơn hàng" },
        { value: 2, label: "Lịch sử đơn hàng" },
      ],
    };
  },
  methods: {
    async searchProductWid() {
      if (!this.searchProduct.trim()) {
        this.activePrdSearch = null;
        this.listSearchedPrd = [];
        this.loadingSearch = true;
        return;
      }
      clearTimeout(this.activeSearch);
      this.activeSearch = setTimeout(async () => {
        await this.getListProduct();
      }, 500);
    },
    async getListProduct() {
      this.loadingSearch = true;
      let data = {};
      data.companyCode = this.app.user.companyCode;
      data.limit = 25;
      data.search = this.searchProduct;
      data.wid = this.selectedWarehouse;
      data.start = 0;
      const res = await HTTP.post("/api/stock/searchProduct", data);
      this.listSearchedPrd = res.data;
      this.loadingSearch = false;
    },
    // Tồn kho/giữ hàng của 1 sản phẩm ở kho đang chọn — an toàn khi storeProduct chưa có.
    getStoreStock(code) {
      return (
        this.app.localData?.storeProduct?.[code]?.[this.selectedWarehouse] || {}
      );
    },
    addProductToOrder(product) {
      product.amount = 1;
      let existPrd = this.orderParam.items?.findIndex(
        (prd) => prd.code == product.code
      );
      if (existPrd == -1) {
        this.orderParam.items.push(product);
      } else {
        let sw = this.orderParam.items;
        sw[existPrd].amount = sw[existPrd].amount + 1;
        this.orderParam.items = JSON.parse(JSON.stringify(sw));
      }
      this.updateTotalPrice();
    },
    updateTotalPrice() {
      if (!this.orderParam.items) return;
      this.orderParam.totalPrice = 0;
      if (!this.price_policy || this.price_policy === "retail_price") {
        for (const it of this.orderParam.items) {
          this.orderParam.totalPrice +=
            parseInt(it.retailPrice) * parseInt(it.amount || 0);
        }
      } else {
        for (const it of this.orderParam.items) {
          if (!it.wholesale_price) it.wholesale_price = 0;
          this.orderParam.totalPrice +=
            parseInt(it.wholesalePrice) * parseInt(it.amount || 0);
        }
      }
      let discount = this.orderParam.discount
        ? parseInt(this.orderParam.discount)
        : 0;
      let otherFee = this.orderParam.otherFee
        ? parseInt(this.orderParam.otherFee)
        : 0;
      let totalPrice =
        this.orderParam.typeDiscount === "VND"
          ? parseInt(this.orderParam.totalPrice) - discount + otherFee
          : parseInt(this.orderParam.totalPrice) -
            (discount / 100) * parseInt(this.orderParam.totalPrice) +
            otherFee;
      this.orderParam.totalPrice = totalPrice > 0 ? Math.round(totalPrice) : 0;
      let paid = this.orderParam.paid ? parseInt(this.orderParam.paid) : 0;
      this.orderParam.pickMoney =
        totalPrice - paid > 0 ? Math.round(totalPrice - paid) : 0;
      if (this.orderParam.payment_type_id != 1) {
        let shipping_fee = this.orderParam.shipping_fee
          ? parseInt(this.orderParam.shipping_fee)
          : 0;
        this.orderParam.pickMoney += shipping_fee;
      }
    },
    removeProductFromOrder(code) {
      this.orderParam.items = this.orderParam.items.filter(
        (item) => item.code != code
      );
      this.updateTotalPrice();
    },
    // formatCurrency(value) {
    //   return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
    // },
    async getInitData() {
      const initData = await HTTP.get("/api/stock/getInitData", {
        params: { companyCode: this.app.user.companyCode },
      });
      let adressCache = sessionStorage.getItem(this.app.user.companyCode);
      if (adressCache != null) {
        this.app.localData = { ...initData.data, ...JSON.parse(adressCache) };
      } else {
        const address = await HTTP.get("/api/stock/address");
        sessionStorage.setItem(
          this.app.user.companyCode,
          JSON.stringify(address.data)
        );
        this.app.localData = { ...initData.data, ...address.data };
      }
      this.setupMultiselect(this.app.localData.provinces);
      this.getShippingUnit();
      this.getWarehouses();
    },
    setupMultiselect(localData) {
      this.provinces = [];
      Object.entries(localData).map((item) => {
        this.provinces.push({
          provinceId: item[0],
          name: item[1].name,
          children: item[1].children,
          viettelCode: item[1].viettelCode,
        });
      });
    },
    chooseProvince(e) {
      this.orderParam.customer_district_id = null;
      this.orderParam.customer_ward_id = null;
      this.wardSelected = null;
      this.districtsSelected = null;
      this.errorWard = false;
      if (!e)
        this.orderParam.customer_province_id =
          this.provincesSelected.provinceId; /*Set province id for order after selected*/
      this.wards = [];
      this.districtsId =
        this.app.localData.provinces[
          this.orderParam.customer_province_id || e.provinceId
        ].children;
      this.districts = this.districtsId.map((ele) => {
        return { code: ele, ...this.app.localData.districts[ele] };
      });
      if (e.provinceId) {
        let province = this.app.localData.provinces[e.provinceId];
        this.provincesSelected = {
          children: province.children,
          name: province.name,
          provinceId: e.provinceId,
          viettelCode: province.viettelCode,
        }; /*Object Province Selected*/
        this.orderParam.customer_district_id = e.districtId;
        this.chooseDistrict(e);
      }
    },
    chooseDistrict(e) {
      this.orderParam.customer_ward_id = null;
      this.wardSelected = null;
      this.errorWard = false;
      if (!e)
        this.orderParam.customer_district_id = this.districtsSelected.code;
      //load ward data
      this.wardsId = this.districts.find(
        (item) =>
          item.code === e.districtId ||
          item.code === this.orderParam.customer_district_id
      ).children;
      this.wards = this.wardsId.map((ele) => {
        return { code: ele, ...this.app.localData.wards[ele] };
      });

      if (e.provinceId) {
        let district = this.app.localData.districts[e.districtId];
        this.districtsSelected = {
          code: e.districtId,
          name: district.name,
          parent: district.parent,
          children: district.children,
          viettelCode: district.viettelCode,
        };
        this.orderParam.customer_ward_id = e.wardId;
        this.chooseWard(e);
      }
    },
    chooseWard(e) {
      this.errorWard = false;
      if (!e)
        return (this.orderParam.customer_ward_id = this.wardSelected.code);
      let ward = this.app.localData.wards[e.wardId];
      this.wardSelected = {
        code: e.wardId,
        name: ward.name,
        parent: ward.parent,
      };
    },
    updateOrderSwItems(event, code) {
      let value = parseInt(event || 0);
      let sw = this.orderParam.items.map((item) => {
        if (item.code === code) {
          item.amount = value;
        }
        return item;
      });
      this.orderParam.items = JSON.parse(JSON.stringify(sw));
      this.updateTotalPrice();
    },
    getShippingUnit() {
      if (this.app.localData.companyInfo) {
        let lgxSetup = this.app.localData.companyInfo;
        this.logisticItems.forEach((item) => {
          if (
            item.id == "AHAMOVE" &&
            lgxSetup["ahamove"] &&
            lgxSetup["ahamove"]["token"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "JNT" &&
            lgxSetup["jnt"] &&
            lgxSetup["jnt"]["jntCode"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "Viettel Post" &&
            lgxSetup["viettelPost"] &&
            lgxSetup["viettelPost"]["vtpToken"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "GHN" &&
            lgxSetup["ghn"] &&
            lgxSetup["ghn"]["ghnToken"] &&
            lgxSetup["ghn"]["ghnShopId"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "GHTK" &&
            lgxSetup["ghtk"] &&
            lgxSetup["ghtk"]["ghtkApiToken"] &&
            lgxSetup["ghtk"]["ghtkShopId"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "SUPERSHIP" &&
            lgxSetup["superShip"] &&
            lgxSetup["superShip"]["superShipToken"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "CNTSHIP" &&
            lgxSetup["cntShip"] &&
            lgxSetup["cntShip"]["cntShopId"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "sps" &&
            lgxSetup["ninjaVan"] &&
            lgxSetup["ninjaVan"]["branchID"]
          ) {
            item.connected = true;
          }
          if (
            item.id == "Shopee Xpress" &&
            lgxSetup["shopeeX"] &&
            lgxSetup["shopeeX"]["userSecret"] &&
            lgxSetup["shopeeX"]["userId"]
          ) {
            item.connected = true;
          }
        });
        this.logisticItems.sort((a, b) => b.connected - a.connected);
      }
    },
    getWarehouses() {
      if (this.app.localData.warehouses) {
        this.warehouses = Object.values(
          this.app.localData.warehouses.warehouses
        );
        this.selectedWarehouse = this.warehouses[0].wid;
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleInputFormat(number, type, product) {
      let numberType = number.toString().split(",").join("");
      let value = 0;
      switch (type) {
        case "paid": {
          value = this.separateNumberByThousand(numberType);
          this.paid = value !== "0" ? value : "";
          this.orderParam.paid = Number(numberType);
          this.updateTotalPrice();
          break;
        }
        case "discount":
          if (this.orderParam.typeDiscount !== "percent") {
            value = this.separateNumberByThousand(numberType);
            this.discount = value !== "0" ? value : "";
            this.orderParam.discount = Number(numberType);
            this.updateTotalPrice();
          } else {
            if (numberType > 100) {
              this.alert("error", "Chiết khấu không được lớn 100");
              this.discount = null;
              this.orderParam.discount = 0;
            } else {
              this.discount = numberType;
              this.orderParam.discount = Number(numberType);
            }
          }
          this.updateTotalPrice();
          break;
        case "product":
          value = this.separateNumberByThousand(numberType);
          if (this.price_policy == "retail_price") {
            product.retailPrice = Number(numberType);
          } else {
            product.wholesalePrice = Number(numberType);
          }
          this.updateTotalPrice();
          break;
        case "shippingFee":
          value = this.separateNumberByThousand(numberType);
          this.shipping_fee = value !== "0" ? value : "";
          this.orderParam.shipping_fee = Number(numberType);
          this.updateTotalPrice();
          break;
        case "otherFee":
          value = this.separateNumberByThousand(numberType);
          this.otherFee = value !== "0" ? value : "";
          this.orderParam.otherFee = Number(numberType);
          this.updateTotalPrice();
          break;
      }
    },
    separateNumberByThousand(number) {
      number = Number(number) || 0;
      return number.toLocaleString("en-US");
    },
    formatCurrency(value) {
      if (!value) return "0 đ";
      return new Intl.NumberFormat("vi-VN").format(value) + " đ";
    },
    async getHistoryPhone() {
      this.infoSuggest = [];
      const resp = await HTTP.get(`/api/stock/customer?phone=${this.contact.phone}`);
      if (resp.data?.orders.length) {
        this.infoSuggest.push(resp.data.orders[0].customer);
      } else {
        if (!resp.data?.address || !resp.data?.phone) return;
        this.infoSuggest.push(resp.data);
      }
    },
    useInfoSuggest(customer) {
      this.appliedAddress = {
        name: customer.name,
        phone: customer.phone,
        address: [
          customer.address,
          this.app.localData.wards[customer.wardId]?.name || "",
          this.app.localData.districts[customer.districtId]?.name || "",
          this.app.localData.provinces[customer.provinceId]?.name || "",
        ]
          .filter(Boolean)
          .join(", "),
      };
      this.orderParam.customer_name =
        this.orderParam.customer_name != ""
          ? this.orderParam.customer_name
          : customer.name;
      this.orderParam.customer_phone = customer.phone;
      this.orderParam.customer_address = customer.address;
      this.orderParam.customer_province_id = customer.provinceId;
      this.chooseProvince(customer);
      this.infoSuggest = [];
    },
    async submit() {
      let swItems = this.orderParam.items.map((it) => ({
        productCode: it.code,
        amount: parseInt(it.amount),
        price: parseInt(it.retailPrice),
        ...(it.wholesale_price !== undefined
          ? { wholesale_price: parseInt(it.wholesalePrice) }
          : {}),
        name: this.app.localData.products?.[it.code]
          ? this.app.localData.products?.[it.code].name
          : it.name,
        image: this.app.localData.products?.[it.code]
          ? this.app.localData.products?.[it.code].image
          : it.image,
        ...(it.type === "combo" ? { salework: it.salework } : {}),
        ...(this.app.localData.products?.[it.code]
          ? { cost: this.app.localData.products?.[it.code].cost }
          : {}),
        ...(this.app.localData.products?.[it.code]
          ? {
              currentAmount:
                this.app.localData.storeProduct?.[it.code] &&
                this.app.localData.storeProduct[it.code][this.selectedWarehouse]
                  ? this.app.localData.storeProduct[it.code][
                      this.selectedWarehouse
                    ].total
                  : 0,
            }
          : {}),
        ...(this.app.localData.products?.[it.code]
          ? {
              bid: this.app.localData.products?.[it.code].warehouses.find(
                (i) => i.wid === this.selectedWarehouse
              )
                ? this.app.localData.products?.[it.code].warehouses.find(
                    (i) => i.wid === this.selectedWarehouse
                  ).bid
                : "BinDefault",
            }
          : {}),
      }));
      let currentWarehouse = this.selectedWarehouse;
      for (let it of swItems) {
        if (!this.app.localData.settings?.addOrder) {
          if (!it.salework) {
            // Chỉ kiểm tra khi có dữ liệu tồn kho; thiếu thì bỏ qua (không chặn nhầm).
            const s =
              this.app.localData.storeProduct?.[it.productCode]?.[currentWarehouse];
            if (
              s &&
              s.total + s.exp_amount - s.book - s.wait - parseInt(it.amount) < 0
            ) {
              this.$message.error(
                `Sản phẩm ${it.productCode} hiện đang hết hàng`
              );
              return;
            }
          } else {
            for (let prd of it.salework) {
              const s =
                this.app.localData.storeProduct?.[prd.code]?.[currentWarehouse];
              if (
                s &&
                s.total +
                  s.exp_amount -
                  s.book -
                  s.wait -
                  Number(it.amount) * Number(prd.amount) <
                  0
              ) {
                this.$message.error(
                  `Sản phẩm ${prd.code} của Combo ${it.productCode} hiện đang hết hàng`
                );
                return;
              }
            }
          }
        }
      }
      let param = {
        swItems: swItems,
        price_policy: this.price_policy,
        ...(this.tag_logistic != "" ? { tag_logistic: this.tag_logistic } : {}),
        customer_name: this.orderParam.customer_name.trim(),
        customer_phone: this.orderParam.customer_phone,
        channel: "Salework",
        payment_type_id: this.orderParam.payment_type_id,
        customer_phoneExtend: "",
        customer_address: this.orderParam.customer_address,
        customer_province_id: this.provincesSelected
          ? this.provincesSelected.provinceId
          : "",
        customer_district_id: this.districtsSelected
          ? this.districtsSelected.code
          : "",
        customer_ward_id: this.wardSelected ? this.wardSelected.code : "",
        discount: parseInt(this.orderParam.discount) || 0,
        typeDiscount: this.orderParam.typeDiscount,
        paid: parseInt(this.orderParam.paid) || 0,
        shipping_fee: parseInt(this.orderParam.shipping_fee) || 0,
        logistic: this.orderParam.logistic,
        totalPrice: parseInt(this.orderParam.totalPrice),
        package: this.orderParam.package,
        note_customer: this.orderParam.note_customer,
        note_shipper: this.orderParam.note_shipper,
        note: this.orderParam.note,
        createdBy: this.app.user.swUsername,
        return_storeProduct: true,
        source: "contact",
        otherFee: this.orderParam.otherFee || 0,
        company_id: this.app.user.companyCode,
        wid: this.selectedWarehouse,
        pickMoney: parseInt(this.orderParam.pickMoney),
        // ...this.orderDetails.selectedLgx === "AHAMOVE" || estimateFee? {
        //   payment_method: (this.orderDetails.payment_method === 'CASH' && this.orderDetails.payment_type_id == 2) ? 'CASH_BY_RECIPIENT' : this.payment_method,
        //   service_id: serviceType ? serviceType : ''
        // } : {}, /* For ahamove */
        // ...this.orderDetails.selectedLgx != '' && this.orderDetails.deliveryType == 'TPL' ? {
        //   serviceType: this.logisticItems.find(s=> s.id === this.orderDetails.selectedLgx ).serviceType
        // }:{},
        shopId: "SaleworkWarehouse",
        selectedPayment: "Tiền mặt",
        // zaloConversationId: this.conversation.id
      };
      let request = {
        method: "add",
        params: param,
      };
      this.loading = true;
      await HTTP.post("/api/stock/addOrder", request);
      this.alert("success", "Lên đơn thành công");
      this.$emit("close");
      // this.resetDataOrder();
      this.loading = false;
      // this.getOrdersHistory();
    },
    async getOrdersHistory() {
      const resp = await HTTP.get(`/api/stock/orders?phone=${this.orderParam.customer_phone}`);
      this.ordersHistory = resp.data;
    },
    showOrderDetail(order) {
      this.orderDetail = order;
      this.showDetailOrder = true;
    },
    changeAddress() {
      this.appliedAddress = {
        address: [
          this.orderParam.customer_address,
          this.app.localData.wards[this.orderParam.customer_ward_id]?.name ||
            "",
          this.app.localData.districts[this.orderParam.customer_district_id]
            ?.name || "",
          this.app.localData.provinces[this.orderParam.customer_province_id]
            ?.name || "",
        ]
          .filter(Boolean)
          .join(", "),
      };
    },
    changeDiscountType(type) {
      this.discount = 0;
      this.orderParam.typeDiscount = type;
      this.handleInputFormat(0, "discount");
    },
    handleChangeTab(tab) {
      this.activeTab = tab;
      if (tab === 2) {
        this.getOrdersHistory();
      }
    },
    getMenuStyle(type) {
      return type.value == this.activeTab
        ? this.activeMenuStyle("#094fad")
        : this.normalMenuStyle("#000000");
    },
    activeMenuStyle(color) {
      //#0A58C0
      return {
        "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        "font-weight": "bold",
        color: color,
        "background-color": this.setTransparencyHex(color, 0.1),
      };
    },
    normalMenuStyle(color) {
      //#696B72
      return {
        //   "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        color: color,
        "font-weight": "500",
        "background-color": "transparent",
      };
    },
    setTransparencyHex(hex, opacity) {
      let color = hex.substring(1, hex.length);
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return "#" + color + _opacity.toString(16).toUpperCase();
    },
  },
  computed: {
    totalNoFee() {
      let totalCost = this.orderParam.items.reduce((agg, val) => {
        if (this.orderParam.price_policy == "retail_price") {
          agg += parseInt(val.retailPrice) * parseInt(val.amount || 0);
        } else {
          if (!val.wholesalePrice) val.wholesalePrice = 0;
          agg += parseInt(val.wholesalePrice) * parseInt(val.amount || 0);
        }
        return agg;
      }, 0);
      return totalCost;
    },
    options_tag_logistic_computer() {
      if (this.orderParam.logistic === "GHTK") {
        let data = [...this.options_tag_logistic];
        data.push({ value: 17, text: "Giao hàng 1 phần chọn sản phẩm" });
        data.push({ value: 18, text: "Giao hàng 1 phần đổi trả hàng" });
        return data;
      }
      return this.options_tag_logistic;
    },
    disabledBtnSubmit() {
      if (
        !this.orderParam.customer_name.trim() ||
        !this.orderParam.customer_phone.trim() ||
        !this.provincesSelected ||
        !this.provincesSelected.provinceId ||
        !this.districtsSelected ||
        !this.districtsSelected.code ||
        !this.wardSelected ||
        !this.wardSelected.code ||
        !this.orderParam.customer_address.trim()
      ) {
        return true;
      }
      if (
        /((^\W\S)?^(([+]84[1-9]{1})|([0][3|5|7|8|9])){1}[0-9]{2})[.]?[0-9]{3}[.]?[0-9]{3}\b/.test(
          this.orderParam.customer_phone
        ) !== true
      ) {
        return true;
      }
      if (!this.orderParam.items.length) {
        return true;
      }
      if (this.orderParam.items.filter((s) => s.amount === 0).length)
        return true;
      if (!this.orderParam.logistic) return true;
      return false;
    },
  },
  mounted() {
    if (Object.keys(this.app.localData).length === 0) {
      this.getInitData();
    } else {
      this.setupMultiselect(this.app.localData.provinces);
      this.getShippingUnit();
      this.getWarehouses();
    }
    this.orderParam.customer_name = this.contact.displayName;
    this.orderParam.customer_phone = this.contact.phone;
    // this.getHistoryPhone();
  },
};
</script>

<style scoped>
.search-suggestions {
  background-color: white;
  border: 1px solid #d4d4d4;
  width: 47%;
  position: absolute;
  z-index: 999;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 4px;
  margin-top: 2px;
}

.btn-active-1 {
  background: rgba(23, 105, 215, 1);
  color: white;
  border: none;
}

.text-ellipsis {
  display: inline-block;
  vertical-align: sub;
  max-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-dialog__wrapper.over >>> .el-dialog {
  height: calc(100vh - 120px);
  max-width: 70%;
}

.btn-active {
  border-color: #094fad;
  color: #094fad;
}

.hidden-header >>> .el-dialog__header {
  display: none;
  border-bottom: none !important;
}

.hidden-header >>> .el-dialog__body {
  padding-top: 0;
}
</style>